import styled from 'styled-components';
import { Badge } from 'react-bootstrap';

export const TableHeaderWrapper = styled.table`
    & > thead > tr > th {
        color: white;
        overflow: hidden;
        padding: 5px 0px 5px 3px !important;
    }
`;

export const TableRowWrapper = styled.tr`
    & > td {
        padding: 3px 0px 3px 3px !important;
        vertical-align: middle !important;
    }
`;

export const SummaryTitles = styled.tr`
    & > td {
        background-color: #00004c;
        color: white;
        font-size: 9px;
    }
`;

export const SummaryValues = styled.tr`
    & > td {
        font-size: 12px;
    }
`;

interface IGridWrapperProps {
    height?: string
}

export const GridWrapper = styled.div<IGridWrapperProps>`
    height: ${p => p.height ? p.height : 'calc(100vh - 175px)'};
    font-family: Roboto;

    .action-menu {
        overflow: visible;
        border-bottom: none;
        line-height: 28px;
        border-color: #ccc;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: #133366;
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    // .ag-row-hover {
    //     background-color: red !important;
    //     color: white;
    // }

    .ag-row-selected > .ag-cell {
        background-color: yellow !important;
        color: black;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .center-list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        color: #fff;
    }

    .center-list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
        font-size: 12px;
    }

    .center-list-notes-header {
        background-color: dimgray;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        color: #fff;
    }

    .center-list-notes-cell {
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
        font-size: 12px;
    }

    /* paired exchange */

    .center-list-paired-exchange-group-header {
        background-color: #F6CC9F;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
    }

    .center-list-paired-exchange-header {
        background-color: #F6CC9F;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .center-list-paired-exchange-cell {
        background-color: #F6CC9F;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
    }

    // .ag-row-selected > .ag-cell.center-list-paired-exchange-cell {
    //     background-color: yellow !important;
    //     color: black !important;
    // }

    /* advanced donation */

    .center-list-advanced-donation-group-header {
        background-color: #DFBDDB;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
    }

    .center-list-advanced-donation-header {
        background-color: #DFBDDB;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .center-list-advanced-donation-cell {
        background-color: #DFBDDB;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
    }

    /* kfl */

    .center-list-kfl-group-header {
        background-color: #BFC9CA;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
    }

    .center-list-kfl-header {
        background-color: #BFC9CA;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .center-list-kfl-cell {
        background-color: #BFC9CA;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
    }

    /* automated workflow */

    .center-list-automated-workflow-group-header {
        background-color: #9FCAE6;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
    }

    .center-list-automated-workflow-header {
        background-color: #9FCAE6;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .center-list-automated-workflow-cell {
        background-color: #9FCAE6;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
    }

    /* donor search */

    .center-list-donor-search-group-header {
        background-color: #AECCAE;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
    }

    .center-list-donor-search-header {
        background-color: #AECCAE;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .center-list-donor-search-cell {
        background-color: #AECCAE;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
    }

    /* other */

    .center-list-other-group-header {
        background-color: #DBDBDB;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
    }

    .center-list-other-header {
        background-color: #DBDBDB;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .center-list-other-cell {
        background-color: #DBDBDB;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
    }

    /* referrals */

    .center-list-referrals-group-header {
        background-color: #DDDDBB;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
    }

    .center-list-referrals-header {
        background-color: #DDDDBB;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        font-weight: 500;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        padding-bottom: 5px;
    }

    .center-list-referrals-cell {
        background-color: #DDDDBB;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
    }

    /* partner center */

    .center-list-partner-center-group-header {
        background-color: #A7B266;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
    }

    .center-list-partner-center-header {
        background-color: #A7B266;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .center-list-partner-center-cell {
        background-color: #A7B266;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
    }

    /* billing */

    .center-list-billing-group-header {
        background-color: #BBDDDD;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
    }

    .center-list-billing-header {
        background-color: #BBDDDD;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .center-list-billing-cell {
        background-color: #BBDDDD;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
    }

    /* serologies */

    .center-list-serologies-group-header {
        background-color: #992244;
        color: white;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
    }

    .center-list-serologies-header {
        background-color: #992244;
        color: white;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .center-list-serologies-cell {
        background-color: #992244;
        color: white;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
    }

    /* saturation */

    .center-list-saturation-group-header {
        background-color: yellow;
        color: black;
        display: flex;
        justify-content: center;
        // align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
    }

    .center-list-saturation-header {
        background-color: yellow;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #ccc;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .center-list-saturation-cell {
        background-color: yellow;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
    }

    .center-list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .totals {
        font-weight: 600;
        background-color: #ddd;
    }

    .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
        background-color: lightgoldenrodyellow;
    }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customHeaderLabel {
        // margin-left: 5px;
        // float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        // margin-left: 3px;
        position: absolute;
        right: 0;
        top: 0;
        padding-right: 2px;
    }

    .customSortUpLabel {
        // float: left;
        //margin-left: 3px;
        position: absolute;
        right: 0;
        top: 0;
        padding-right: 2px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    // .active {
    //     color: cornflowerblue;
    // }

    .dropdown-menu > li > a:hover, .dropdown-menu > li > a:focus {
        background-color: #ddd;
    }

    .ag-cell {
        padding-left: 0px;
        padding-right: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ag-cell > .ag-react-container {
        width: 100%;
    }

    span.targeted {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    span.targeted > .dropdown {
        padding: 0px;
    }

    span.targeted > .dropdown > .dropdown-toggle {
        background-color: transparent;
        color: green;
        font-weight: 700;
        font-size: 16px;
        padding: 0px 10px 0px 10px;
        border: 0 none;
    }

    span.active-targeted > .dropdown > .dropdown-toggle {
        background-color: transparent;
        color: yellow;
        font-weight: 700;
        font-size: 16px;
        padding: 0px 10px 0px 10px;
        border: 0 none;
    }

    span.category > .dropdown > .dropdown-toggle {
        background-color: transparent;
        // color: green;
        font-weight: 700;
        font-size: 16px;
        padding: 0px 10px 0px 10px;
        border: 0 none;
    }

    div.target {
        //color: #EAEAEA;
        //opacity: 0.35;
    }

    .ag-cell-inline-editing {
        height: 28px !important;
        border-color: transparent !important;
    }

    // input[class^='ag-']:not([type]),
    // input[class^='ag-'][type='number'],
    // input[class^='ag-'][type='tel'],
    // input[class^='ag-'][type='date'],
    // input[class^='ag-'][type='datetime-local'],
    // textarea[class^='ag-'],
    input[class^='ag-'][type='text'] {
        border-color: #bbb !important;
        border-radius: 4px;
        height: 26px !important;
        margin-top: 1px;
    }

    .annual-goal-editor > input.form-control {
        padding: 3px 6px !important;
        height: 26px !important;
        width: 40px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
    }

    .annual-goal-editor > button {
        padding: 0px 3px 0px 3px;
        height: 26px;
    }

    .annual-goal-editor > button.ok {
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
    }

    .annual-goal-editor > button.cancel {
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
    }

    .annual-goal-editor > button > span.glyphicon {
        font-size: 10px;
    }
`;

interface IGridWrapperSmallProps {
    fontSize?: string
}

export const GridWrapperSmall = styled<IGridWrapperSmallProps>(GridWrapper)`
    height: 80vh;
    font-family: Roboto;
    font-size: ${p => p.fontSize ? p.fontSize : '12px'};

    .action-menu {
        overflow: visible;
        border-bottom: none;
        line-height: 28px;
        border-color: #ccc;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: #123;
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row-selected > .ag-cell {
        background-color: yellow !important;
        color: black;
    }
    
    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .center-list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-cell span {
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-paired-exchange-group-header {
        background-color: #F6CC9F;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #EFAB60;
        font-weight: 500;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-paired-exchange-header {
        background-color: #F6CC9F;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #EFAB60;
        font-weight: 500;
        padding-bottom: 5px;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-paired-exchange-cell {
        background-color: #F6CC9F;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #EFAB60;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-advanced-donation-group-header {
        background-color: #DFBDDB;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #CA92C4;
        font-weight: 500;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-advanced-donation-header {
        background-color: #DFBDDB;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #CA92C4;
        font-weight: 500;
        padding-bottom: 5px;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-advanced-donation-cell {
        background-color: #DFBDDB;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #CA92C4;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-donor-shield-group-header {
        background-color: #E48896;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #D64C62;
        font-weight: 500;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-donor-shield-header {
        background-color: #E48896;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #D64C62;
        font-weight: 500;
        padding-bottom: 5px;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-donor-shield-cell {
        background-color: #E48896;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #D64C62;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-automated-workflow-group-header {
        background-color: #9FCAE6;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #60A7D5;
        font-weight: 500;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-automated-workflow-header {
        background-color: #9FCAE6;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #60A7D5;
        font-weight: 500;
        padding-bottom: 5px;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-automated-workflow-cell {
        background-color: #9FCAE6;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #60A7D5;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-donor-search-group-header {
        background-color: #AECCAE;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #79AB79;
        font-weight: 500;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-donor-search-header {
        background-color: #AECCAE;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #79AB79;
        font-weight: 500;
        padding-bottom: 5px;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-donor-search-cell {
        background-color: #AECCAE;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #79AB79;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-other-group-header {
        background-color: #DBDBDB;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #B7B7B7;
        font-weight: 500;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-other-header {
        background-color: #DBDBDB;
        color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #B7B7B7;
        font-weight: 500;
        padding-bottom: 5px;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-other-cell {
        background-color: #DBDBDB;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #B7B7B7;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-header span {
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .center-list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .totals {
        font-weight: 600;
        background-color: #ddd;
    }

    .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
        background-color: lightgoldenrodyellow;
    }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .customHeaderLabel > span {
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }
    
    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }

    .dropdown > .dropdown-toggle {
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .dropdown-menu {
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .dropdown-menu > li > a:hover, .dropdown-menu > li > a:focus {
        background-color: #ddd;
    }

    .ag-cell > .ag-react-container > span {
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }
`;

export const GridWrapperSingle = styled.div`
    height: 160px;
    font-family: Roboto;
    
    .ag-header { 
        font-family: Roboto;
        color: #333;
    }

    .ag-header-cell {
        align-items: flex-end;
        padding-bottom: 5px;
        text-align: center;
        justify-content: center;
    }

    .ag-cell {
        text-align: center;
        border-right: 1px solid #ddd;
    }

    .ag-horizontal-left-spacer {
        overflow-x: hidden;
    }

    .ag-header-group-cell-label {
        justify-content: center;
    }

    .center-list-cell {
        // border-bottom: none;
        text-align: center;
        line-height: 28px;
        // border-color: #ccc;
        // font-size: 10px;
        border-right: 1px solid #ccc;
    }

    .center-list-paired-exchange-group-header {
        // background-color: #F6CC9F;
        // color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // border-color: #EFAB60;
        // border-color: #ccc;
        // font-weight: 500;
        border: 1px solid #ccc;
        border-top-width: 1px !important;
    }

    .center-list-paired-exchange-header {
        // background-color: #F6CC9F;
        // color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // border-color: #EFAB60;
        // font-weight: 500;
        padding-bottom: 5px;
        border-right: 1px solid #ccc;
    }

    .center-list-paired-exchange-cell {
        // background-color: #F6CC9F;
        // color: black;
        // border-bottom: none;
        text-align: center;
        line-height: 28px;
        // border-color: #EFAB60;
    }

    .center-list-advanced-donation-group-header {
        // background-color: #DFBDDB;
        // color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // border-color: #CA92C4;
        // font-weight: 500;
    }

    .center-list-advanced-donation-header {
        // background-color: #DFBDDB;
        // color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // border-color: #CA92C4;
        // font-weight: 500;
        padding-bottom: 5px;
    }

    .center-list-advanced-donation-cell {
        // background-color: #DFBDDB;
        // color: black;
        // border-bottom: none;
        text-align: center;
        line-height: 28px;
        // border-color: #CA92C4;
    }

    .center-list-donor-shield-group-header {
        // background-color: #E48896;
        // color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // border-color: #D64C62;
        font-weight: 500;
    }

    .center-list-donor-shield-header {
        // background-color: #E48896;
        // color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // border-color: #D64C62;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .center-list-donor-shield-cell {
        // background-color: #E48896;
        // color: black;
        // border-bottom: none;
        text-align: center;
        line-height: 28px;
        // border-color: #D64C62;
    }

    .center-list-automated-workflow-group-header {
        // background-color: #9FCAE6;
        // color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // border-color: #60A7D5;
        font-weight: 500;
    }

    .center-list-automated-workflow-header {
        // background-color: #9FCAE6;
        // color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // border-color: #60A7D5;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .center-list-automated-workflow-cell {
        // background-color: #9FCAE6;
        // color: black;
        // border-bottom: none;
        text-align: center;
        line-height: 28px;
        // border-color: #60A7D5;
    }

    .center-list-donor-search-group-header {
        // background-color: #AECCAE;
        // color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // border-color: #79AB79;
        font-weight: 500;
    }

    .center-list-donor-search-header {
        // background-color: #AECCAE;
        // color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // border-color: #79AB79;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .center-list-donor-search-cell {
        // background-color: #AECCAE;
        // color: black;
        // border-bottom: none;
        text-align: center;
        line-height: 28px;
        // border-color: #79AB79;
    }

    .center-list-other-group-header {
        // background-color: #DBDBDB;
        // color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // border-color: #B7B7B7;
        font-weight: 500;
    }

    .center-list-other-header {
        // background-color: #DBDBDB;
        // color: black;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // border-color: #B7B7B7;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .center-list-other-cell {
        // background-color: #DBDBDB;
        // color: black;
        // border-bottom: none;
        text-align: center;
        line-height: 28px;
        // border-color: #B7B7B7;
    }

    .center-list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        border-right: 1px solid #ccc;
        border-top: 1px solid #ccc;
    }

    .center-list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    // .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
    //     display: flex;
    //     justify-content: center;
    // }

    //         .totals {
    //             font-weight: 600;
    //             background-color: #ddd;
    //         }

    //         .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
    //             background-color: lightgoldenrodyellow;
    //         }
    //     }
    // .ag-icon.ag-icon-asc {
    //     color: white;
    // }

    // .ag-icon.ag-icon-desc {
    //     color: white;
    // }

    // .customHeaderLabel {
    //     margin-left: 5px;
    //     float: left;
    //     text-align: center;
    // }
    // .customSortDownLabel {
    //     // float: left;
    //     margin-left: 3px;
    // }
    // .customSortUpLabel {
    //     // float: left;
    //     margin-left: 3px;
    // }
    // .customSortRemoveLabel {
    //     float: left;
    //     font-size: 11px;
    //     margin-left: 3px;
    // }
    // .active {
    //     color: cornflowerblue;
    // }
`;

export const HeaderWrapper = styled.span`
    font-weight: normal;
`;

export const ProductPlanWrapper = styled(Badge)`
    padding: 5px 9px;
    
    :hover {
        border: 1px solid red;
        font-weight: bold;
        text-decoration: underline;
    }
`;

export const FilterWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding-left: 0px;
    padding-right: 0px;
    margin-top: 10px;
    margin-bottom: 20px;
    // border: 1px solid red;

    // & > div {
    //     border: 1px solid red;
    // }

    .paired-exchange {
        background-color: #F6CC9F;
    }

    .kfl {
        background-color: #BFC9CA;
    }

    .advanced-donation {
        background-color: #DFBDDB;
    }

    .automated-workflow {
        background-color: #9FCAE6;
    }

    .donor-search {
        background-color: #AECCAE;
    }
    
    .referrals {
        background-color: #DDDBBD;
    }

    .partner-center {
        background-color: #A7B266;
    }

    .billing {
        background-color: #BBDDDD;
    }

    .serologies {
        background-color: #992244;
        
    }

    .serologies > a {
        color: white;
    }

    .other {
        background-color: #DBDBDB;
    }

    .show-stuff > div:nth-child(1) {
        font-size: 12px;
    }

    @media (max-width: 1823px) {
        justify-content: center;

        .paired-exchange,
        .advanced-donation,
        .automated-workflow,
        .donor-search,
        .other,
        .referrals,
        .partner-center,
        .billing,
        .serologies,
        .fully-utilized,

        .center-type,
        .name-search,
        .show-columns,
        .show-groups,
        .export {
            // font-size: 10px;
            // padding-left: 5px;
            // padding-right: 5px;
        }

        .name-search .input-group-addon,
        .name-search .form-control,
        .name-search .btn,
        .export .btn {
            // font-size: 10px;
            // height: 25px;
            // padding: 2.5px 10px;
        }

        .show-groups div.btn-group > label {
            // font-size: 10px;
        }

        .center-type {
            justify-content: center !important;
            // flex-basis: 25%;
        }

        .name-search {
            //justify-content: center !important;
            // flex-basis: 25%;

        }

        .show-stuff {
            justify-content: center !important;
            // flex-basis: 25%;
        }

        .export {
            justify-content: center !important;
            // flex-basis: 25%;
        }
    }
`;

export const GroupsWrapper = styled.div`
    // #valueItemDrop .dropdown-menu {
    //     padding: 0 10px;
    //     top: 22px;
    //     width: 185px;
    //     box-shadow: none;
    //     border-radius: none;
    // }

    // #valueItemDrop .checkbox label:before {
    //     content: '';
    //     display: inline-block;
    //     width: 16px;
    //     height: 16px;
    //     margin-right: 10px;
    //     position: absolute;
    //     left: 0;
    //     bottom: 4px;
    //     background-color: transparent;
    //     border: 1px solid #ccc;
    // }

    // #valueItemDrop .checkbox input[type=checkbox] {
    //     display: none;
    // }

    // #valueItemDrop .checkbox label {
    //     padding-left: 0px;
    //     // font-weight: bold;
    // }

    #valueItemDrop .checkbox label > span.glyphicon {
        margin-right: 10px;
    }

    // #valueItemDrop .checkbox label:before {
    //     border: 1px solid #ccc;
    //     border-radius: 3px;
    // }

    // #valueItemDrop .checkbox input[type=checkbox]:checked + label:before {
    //     // content: '\2714';
    //     font-size: 15px;
    //     color: #4A90E2;
    //     // text-align: center;
    //     line-height: 14px;
    //     padding: 0px;
    //     font-weight: normal;
    // }

    // #valueItemDrop .selectbox {
    //     border-radius: 5px;
    //     padding: 3px 5px;
    //     width: 100%;
    //     border: 1px solid #A4A4A4;
    //     float: right;
    //     -webkit-appearance: none;
    //     -moz-appearance: none;
    //     appearance: none;
    //     cursor: pointer;
    //     background: url('../images/ExpandArrowDown.svg');
    //     background-repeat: no-repeat;
    //     background-position: 163px 8px;
    //     background-color: white;
    // }
`;

export const PopoverTableWrapper = styled.table`
    & > tbody > tr > td {
        padding-left: 5px;
        padding-right: 5px;
    }
`;